import styled from 'styled-components';
import Collapse from 'components/collapse/Collapse';

export const CollapseStyled = styled(Collapse)`
  margin: 16px 0px;
`;

export const CollapseLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    height: 20px;
    width: 20px;
  }
`;
